<div class="row mhide">
 <div class="col-md-12 nopad">
 <div class="col-md-12 nopad mobile_hide">
 <div class="w_79" style="position: fixed;z-index: 99; ">
 <div class="tabs-header border-bottom">
 <ul>
 <li *ngFor="let data of appservice.User_Role_Menu" [className]="appservice.URL_Location==data.Link ? 'active' : ''" class="" > <a (click)="appservice.load_page(data.Link)">{{data.Menu}}</a></li>
 </ul>
 </div>
 <div class="right-corner">
 <div class="dropdown" style="display: inline-flex;">
 <a class="dropdown-toggle addbtn1" (click)="addReset()" data-toggle="tooltip" data-placement="bottom" title="Add New">
 <i class='bx bx-list-plus'></i>
 </a>
 </div>
 </div>
 </div>
 </div>
 
 <div class="col-md-12 nopad">
 <div class="spin_block" *ngIf="appservice.isload">
 <div class="d-flex justify-content-center">
 <div class="spinner-border text-primary" role="status">
 <span class="sr-only">Loading...</span>
 </div>
 </div>
 </div>
 <div class="m_2 res_table">
 <div class="search-bar_Ext mhide show_bar " style="right: 50px;">
 <li class="bx bx-left-arrow-alt mshow search_back"></li>
 <input type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" class="search-form-control text" placeholder="Search...">
 </div>
 <p-table #dt class="table table-striped custom-table" [value]="Rows" [columns]="cols" [paginator]="true" [rows]="10" [resizableColumns]="true" sortMode="multiple" selectionMode="single" >
 <ng-template pTemplate="header">
 <tr>
 <th *ngFor="let col of cols" [pSortableColumn]="col.field" width="{{col.width}}">
 {{col.header}}
 <p-sortIcon [field]="col.field"></p-sortIcon>
 </th>
 <th width=90>Action</th>
 </tr>
 </ng-template>
 <ng-template pTemplate="body" let-rowData let-car >
 <tr [pSelectableRow]="rowData">
 <td *ngFor="let col of cols">
 {{car[col.field]}}
 </td>
 <td class="text-right">
 <a href="javascript:" style="font-size: 18px;padding: 5px" title="Edit" (click)="onEdit(rowData)"><i class="bx bxs-pencil m-r-5"></i></a>
 <a title="Delete" style="font-size: 18px;padding: 5px;color: firebrick" (click)="onDelete(rowData.ID)"><i class="bx bxs-trash"></i></a>
 </td>
 </tr>
 </ng-template>
 </p-table>
 </div>
 </div>
 </div>
</div>

<!-- Modernized Mobile View for Role Master -->
<div class="row mshow">
 <!-- Sticky Header -->
 <div class="sticky-header">
 <li (click)="appservice.back()" class="bx bx-left-arrow-alt back-btn"></li>
 <label class="header-title-mobile">Role Master</label>
 <div class="right-actions-loan">
 <a class="add-btn-round-mini" (click)="addReset()" title="Add Role">
 <i class='bx bx-plus'></i>
 </a>
 </div>
 </div>

 <div class="col-md-12 nopad mobile-body-report">
 <!-- Search Box -->
 <div class="search-container-mobile">
 <div class="search-box-mini">
 <i class='bx bx-search'></i>
 <input type="text" (input)="dtMob.filterGlobal($event.target.value, 'contains')" placeholder="Search roles...">
 </div>
 </div>

 <div class="spin_block" *ngIf="appservice.isload">
 <div class="d-flex justify-content-center p-5">
 <div class="spinner-border text-primary" role="status"></div>
 </div>
 </div>

 <!-- Role Card List -->
 <div class="results-grid px-3">
 <p-table #dtMob [value]="Rows">
 <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
 <div class="report-card-mobile shadow-sm mb-3">
 <div class="card-head" style="background: #f8fafc; margin: -12px -12px 10px -12px; padding: 8px 12px; border-radius: 12px 12px 0 0;">
 <span class="loan-no">#{{rowIndex+1}} Role ID: {{rowData.ID}}</span>
 <span class="loan-date"><i class='bx bx-user-check'></i> Active</span>
 </div>

 <div class="card-main">
 <div class="customer" style="font-size: 17px; color: #1e3c72; font-weight: 700;">{{rowData.Rights_Name}}</div>
 <div class="mt-2 text-muted" style="font-size: 13px;">
 <i class='bx bx-info-circle mr-1'></i> System defined user access level
 </div>
 </div>

 <div class="card-footer-mini mt-2 pt-2 border-top d-flex justify-content-end align-items-center">
 <div class="d-flex gap-2">
 <button (click)="onEdit(rowData)" class="btn btn-sm btn-outline-primary border-0 p-1">
 <i class='bx bx-edit-alt' style="font-size: 20px;"></i>
 </button>
 <button (click)="onDelete(rowData.ID)" class="btn btn-sm btn-outline-danger border-0 p-1">
 <i class='bx bx-trash' style="font-size: 20px;"></i>
 </button>
 </div>
 </div>
 </div>
 </ng-template>
 </p-table>
 </div>
 </div>
</div>